var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as dataLayer from '../snippets/dataLayer';
import * as gtm from '../snippets/gtm';
import * as ot from '../snippets/onetrust';
import * as optimize from '../snippets/optimize';
export function track(trackParams) {
    return __awaiter(this, void 0, void 0, function () {
        var actions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!trackParams)
                        return [2, Promise.resolve()];
                    actions = getActions(trackParams);
                    pushInitialDataToDataLayer(__assign(__assign({}, actions), trackParams));
                    return [4, loadScripts(__assign(__assign({}, actions), trackParams))];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
function getActions(trackParams) {
    var dataLayerPushInitial = trackParams.dataLayerPushInitial, googleOptimizeId = trackParams.googleOptimizeId, googleTagManagerId = trackParams.googleTagManagerId, language = trackParams.language, market = trackParams.market, oneTrust = trackParams.oneTrust;
    return {
        loadGoogleOptimize: !!googleOptimizeId,
        loadGoogleTagManager: !!googleTagManagerId,
        loadOneTrust: oneTrust && market,
        pushInitialData: dataLayerPushInitial && language && market,
    };
}
function pushInitialDataToDataLayer(_a) {
    var language = _a.language, _b = _a.loggedIn, loggedIn = _b === void 0 ? false : _b, pushInitialData = _a.pushInitialData, market = _a.market, _c = _a.userCountry, userCountry = _c === void 0 ? '' : _c;
    if (pushInitialData) {
        dataLayer.push({
            language: language,
            loggedIn: loggedIn,
            market: market,
            userCountry: userCountry,
        });
    }
}
function loadScripts(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var loaders;
        var loadGoogleOptimize = _b.loadGoogleOptimize, loadGoogleTagManager = _b.loadGoogleTagManager, loadOneTrust = _b.loadOneTrust, googleOptimizeId = _b.googleOptimizeId, googleOptimizeTimeout = _b.googleOptimizeTimeout, googleTagManagerId = _b.googleTagManagerId, googleTagManagerAdditionalData = _b.googleTagManagerAdditionalData, oneTrustDomainScript = _b.oneTrustDomainScript, nonce = _b.nonce;
        return __generator(this, function (_c) {
            loaders = [];
            if (loadGoogleOptimize) {
                loaders.push(optimize.load({ id: googleOptimizeId, timeout: googleOptimizeTimeout }));
            }
            if (loadGoogleTagManager && loadOneTrust) {
                loaders.push(ot.load({ oneTrustDomainScript: oneTrustDomainScript }).then(function () {
                    return gtm.load({
                        id: googleTagManagerId,
                        additionalData: googleTagManagerAdditionalData,
                        nonce: nonce,
                    });
                }));
            }
            else if (loadOneTrust) {
                loaders.push(ot.load({ oneTrustDomainScript: oneTrustDomainScript }));
            }
            else if (loadGoogleTagManager) {
                loaders.push(gtm.load({
                    id: googleTagManagerId,
                    additionalData: googleTagManagerAdditionalData,
                    nonce: nonce,
                }));
            }
            return [2, Promise.all(loaders)];
        });
    });
}
